/**
 * Configuracion del almacen de estados para el manejo de notificaciones a nivel de aplicacion 
 */

/**Definicion de componentes o librerias necesarias y que se complementan con el almacen de estados */
import Vue from 'vue'
import Vuex from 'vuex'

/**Integramos el almacen de estados de Vuejs */
Vue.use(Vuex)

/**
 * Definimos el modulo propio para el manejo de estado de sesion
 */
export default {

    /**Atributo que permite definir espacios de modulo con el fin de registrar los captadores, acciones y mutaciones de forma automatica */
    namespaced: true,

    /**Objeto que permite definir el almacen de estados para el maejo de notificaciones */
    state: {

        /**EStado notificacion defini el mensaje, el tipo y la visibilidad */
        notification: {
            visible: false,
            message: '',
            color: 'info'
        }
    },

    /**Objeto que permite manejar las mutaciones y alterar los estados del almacen */
    mutations: {

        /**Mutacion que permite modificar el estaod de notificaciones */
        message(state, message) {
            state.notification.message = message.message
            state.notification.color = message.type
            state.notification.visible = true
        },

        /**Mutacion que permite manejar el estado de visibilidad de las notificaciones */
        hideNotification(state) {
            state.notification.visible = false
        },
    }
}